module.exports = __webpack_public_path__ + "static/media/rotate.aaa7d450.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/JoinPooch/rotate.png
// module id = 611
// module chunks = 0